import { MapperBase } from '../../utilities/mapper-base';
import { Fact } from '../ui/fact.model';
import { FactResource } from '../resource/fact.resource';
import { DocsInFact } from '../docs-in-fact.model';
import { IssueResource } from '../resource/issue.resource';
import { CustodianResource } from '../resource/custodian.resource';

export class FactToFactResourceMapper extends MapperBase<Fact, FactResource> {
	map(source: Fact): FactResource {
		const dest = {} as FactResource;
		dest.factId = source.id;
		dest.factTitle = source.title;
		dest.dateStart = source.dateStart;
		dest.dateEnd = source.dateEnd;
		dest.contested = source.contested;
		dest.material = source.material;
		dest.docsInFacts = source?.linkedDocuments?.map((item) => {
			const docsInFact = new DocsInFact();
			docsInFact.factId = item.factId;
			docsInFact.docId = item.documentId;
			docsInFact.caseId = item.caseId;
			docsInFact.pageNumber = item.pageNumber;
			return docsInFact;
		}) || [];
		dest.issues = source?.linkedIssues?.map((item) => {
			const issueResource = {} as IssueResource;
			issueResource.issueId = item.id;
			issueResource.issueTitle = item.title;
			return issueResource;
		}) || [];
		dest.custodians = source?.linkedCustodians?.map((item) => {
			const custodianResource = {} as CustodianResource;
			custodianResource.custodianId = item.id;
			custodianResource.name = item.name;
			return custodianResource;
		}) || [];
		return dest;
	}
}


